module.exports = __webpack_public_path__ + "media/pdf/Bonitätsmanager_Flyer_Beileger_Ansicht-8e848933400a2fb9bf92bda39c366068.pdf";